import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserPayment from 'components/payments/UserPayment';

function mapStateToProps(state) {
  const payment = state.paymentReducer;
  return {
    accessType: payment.get('accessType'),
    logo: payment.get('logo'),
    plans: payment.get('plans'),
    productName: payment.get('productName'),
    stripePubKey: payment.get('stripePubKey'),
    userPaymentStatus: payment.get('userPaymentStatus'),
    userPaymentMsg: payment.get('userPaymentMsg')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPayment);


// WEBPACK FOOTER //
// ./src/containers/UserPaymentContainer.js